import { Input, ActionIcon, Flex } from '@mantine/core'
import { IconSearch, IconX } from '@tabler/icons-react'
import { useTranslation } from 'react-i18next'

interface Props {
  search: string
  onSearchChange: (value: string) => void
}

export function FacultySearch({ search, onSearchChange }: Props) {
  const { t } = useTranslation()

  return (
    <Flex align='center' gap='sm' mt='md'>
      <Input
        icon={<IconSearch />}
        placeholder={t('manage_faculty.search_placeholder')}
        size='md'
        radius='xl'
        value={search}
        onChange={
          (e: React.ChangeEvent<HTMLInputElement>) =>
            onSearchChange(e.currentTarget.value)
        }
        rightSection={
          search.length > 0 && (
            <ActionIcon
              onClick={() => onSearchChange('')}
              mr={24}
            >
              <IconX />
            </ActionIcon>
          )
        }
        sx={{ flex: 1 }}
      />
    </Flex>
  )
}
